import { PERMISSIONS_KEY } from '@common/utils'
import { create } from 'zustand'

export type PermissionsStoreState = {
  permissions: string[] | undefined
  loadingPermissions: boolean
  setPermissions: (permissions: string[] | undefined) => void
}

export const usePermissionsStore = create<PermissionsStoreState>(set => ({
  // Restore from sessionStorage so permissions are available immediately on page refresh
  // before the OIDC silent-renew completes
  permissions: (() => {
    try {
      const stored = sessionStorage.getItem(PERMISSIONS_KEY)
      return stored ? (JSON.parse(stored) as string[]) : undefined
    } catch {
      return undefined
    }
  })(),
  loadingPermissions: false,
  setPermissions: permissions => {
    try {
      if (permissions === undefined) {
        sessionStorage.removeItem(PERMISSIONS_KEY)
      } else {
        sessionStorage.setItem(PERMISSIONS_KEY, JSON.stringify(permissions))
      }
    } catch {
      /* ignore storage errors */
    }
    set({ permissions })
  }
}))
